const variants = {
    default: {},
    reverseZStacking: ({ isOpen, theme }) => ({
        zIndex: isOpen ? "sticky" : "0",
        paddingRight: theme.space.sm
    })
};

/* eslint-disable sort-keys */
export default {
    ShowMore: {
        baseStyle: {},
        variants,
        defaultProps: {
            variant: "default"
        }
    }
};
